const extractIconElement = ({ element }) => {
  const svgIcon = element.querySelector(`svg`);
  const imgIcon = element.querySelector(`img`);
  if (svgIcon) {
    const colorSet = svgIcon.getAttribute("color");
    if (colorSet) {
      const path = svgIcon.querySelector("path");
      if (path) path.style.fill = colorSet;
    }
    return svgIcon;
  }
  if (imgIcon) return imgIcon;
  return null;
};
export {
  extractIconElement
};
//# sourceMappingURL=extractIconElement.js.map
